import React, {useEffect} from "react";
import Container from "react-bootstrap/Container";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import CreditCardIcon from "@mui/icons-material/CreditCard";

import { IdcardOutlined } from "@ant-design/icons";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ContactUsContent from '../../../components/comment/contactContent/contactusContent';
const HelpContent = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="get-help-wrap">
      <Container>
        <div className="row">
          <div className="col-lg-12 ">
            <h2 className="main-title">Help & Support</h2>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12">
            <div className="help-main-title">
              <IdcardOutlined />
              <span className="head-title">Join SKYCARS</span>
            </div>

            <div className="help-query">What is Skycars ?</div>

            <div className="detail-wrap">
            SKYCARS is a rental self-drive car service platform in Mumbai city, where you can get cars, you drive yourself for rent based on your affordability and customs choices.
            </div>

            <div className="help-query pays-fuel">Who Pays for Fuel?</div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12">
            {/* <div className="help-main-title">
              <DirectionsCarIcon />
              <span className="head-title">Booking Skycars</span>
            </div> */}

            {/* <div className="help-query">How do i make a booking?</div> */}

            <div className="detail-wrap">
              We have a structured module of payment for the fuel, we provide free fuel with the vehicle that is enough to sustain the 5KM of road drive, and the later drive would upon your fuel expenditure.
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12">
            <div className="help-main-title">
            <DirectionsCarIcon />
              <span className="head-title"> Booking SKYCARS</span>
            </div>

            <div className="help-query">How do I make a Booking?</div>

            <div className="detail-wrap">
            Once you’re signed up over SKYCARS, you will be required to perform your profile documentation fill-up, then you can explore simply our car rental and book your cars at ease.
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12">
            <div className="help-main-title">
              {/* <AccountBalanceWalletIcon /> */}
              <CreditCardIcon />
              <span className="head-title"> Payment and Charges</span>
            </div>

            <div className="help-query">What is included in the Charges?</div>

            <div className="detail-wrap">
            The total charges included in your rental car fare will consider the Insurance Goods and Services Taxes, and refundable Security deposited.
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12">
            <div className="help-main-title">
              <AccountBalanceWalletIcon />
              <span className="head-title">Wallet and Refunds</span>
            </div>

            <div className="help-query">How long do refunds Take?</div>

            <div className="detail-wrap">
            Generally, it takes less than 24 hours for your refund to get proceeded, however, considering payment gateway and banking dependency, it will take two to three days to get your refund reflected in your account.
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12">
            <div className="help-main-title">
              <AccountBalanceWalletIcon />
              <span className="head-title">Deal & Discounts
</span>
            </div>

            <div className="help-query">Can I club two Discount Vouchers?</div>

            <div className="detail-wrap">
            There will be a prospective module for our customers to utilize the benefits of multiple discount vouchers, however, for now, we are working on the module facilitating the parallel window offers.
            </div>
          </div>
        </div>

        {/* <div className="row">
          <div className="col-sm-12">
          <div className="need-more-support">

         
            <div className="help-main-title">
              <span className="head-title">
                Need more support, Please get in touch with us
              </span>
            </div>

            <div className="detail-wrap">
              Vestibulum eu rhoncus ex. Donec sollicitudin nunc sed metus
              tincidunt, quis ultricies purus cursus. Maecenas scelerisque mi
              nec tristique pharetra
            </div>

            
            </div>
          </div>
        </div> */}

        <div className="row">
          <div className="col-sm-12">
          <ContactUsContent /> 
          </div>
        </div>


      </Container>
    </section>
  );
};

export default HelpContent;
